export default __webpack_public_path__ + "static/media/c3.14e56c63.png";